<template>
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      title="About our Product"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="4"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: '상품아이템수집', // 采集
          subtitle: 'Collect',
          text: 'taobao,tmall 해외 사이트에서 아이템을 찾습니다. URL만 입력하시면 해당 아이템을 정보를 가져오고 편집 가능합니다.', // 支持对淘宝、天猫平台的商品信息采集和管理，自动翻译，在线修改图片。
          callout: '01'
        },
        {
          title: '마켓등록', // 上传
          subtitle: 'Publish',
          text: '수집한 상품아이템 판매를 위해 coupang,11st에 정보를 전송합니다.', // 一键上传发布至Coupang、11街等韩国主流电商平台。
          callout: '02'
        },
        {
          title: '국제배송', // 物流
          subtitle: 'Logistics',
          text: '고객님께서 직접 주문하신 중국내 사이트에서 국제배송을 지원하지 않거나 여러 곳의 쇼핑몰에서 주문하신 상품을 한꺼번에 배송받기를 원하실 때, 엘티엘가 대신 중국 내에서 상품을 수령하고 검수하여 고객님의 한국 주소지로 더욱 저렴하고 안전하게 빠른 배송해드립니다.', // 高效率的中韩海空物流，实时查看全程动态信息。
          callout: '03'
        },
      ],
    }),
  }
</script>
